import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { WebinarConnectingComponent } from '../..'

const Connecting = ({
  /**
   * Connected properties
   */
  isConnectingModalVisible,
  showPermissionsHint,
  connectingModalText,
}) => (
  <WebinarConnectingComponent
    isModalOpen={isConnectingModalVisible}
    showPermissionsHint={showPermissionsHint}
    loadingText={connectingModalText}
  />
)

Connecting.propTypes = {
  /**
   * Connected properties
   */
  isConnectingModalVisible: PropTypes.bool,
  showPermissionsHint: PropTypes.bool,
  connectingModalText: PropTypes.string,
}

const mapStateToProps = (state) => ({
  /**
   * Connected properties
   */
  isConnectingModalVisible: state.webinar.isConnectingModalVisible,
  showPermissionsHint: state.webinar.showPermissionsHint,
  connectingModalText: state.webinar.connectingModalText,
})

export default connect(mapStateToProps)(Connecting)
